function checkIsSuperAdmin({ userOrgId }: { userOrgId: string }) {
  const isUserOrgMM = userOrgId === process.env.REACT_APP_MM_ORG_ID;

  return isUserOrgMM;
}

export default checkIsSuperAdmin;
